import React from "react"

const CallToAction = () => {
  return (
    <section className="callToAction">
      <div className="callToAction-text">
        <h1>Try DigiWall</h1>
        <h3>A digit wallet for all</h3>
      </div>

      <div className="callToAction-links">
        <img
          src="/images/Homepage/google-play.svg"
          alt="Google Play store link"
        />
        <img
          className="app-store"
          src="/images/Homepage/app-store.svg"
          alt="App store link"
        />
      </div>

      <form>
        <input type="email" placeholder="Enter your email..." />
        <button type="button">Get started</button>
      </form>
    </section>
  )
}

export default CallToAction
